export default tooltip => {
    if ($('.tooltip').length < 1) {
        return false;
    }

    let $tooltips = $('.tooltip');

    /**
     * Click and mouseover event for desktop, tablet and mobile phones
     */
    $tooltips.on('click mouseover', event => {
        if ($.inArray(Foundation.MediaQuery.current, ['small', 'xsmall']) >= 0) {
            return;
        }

        let $tooltip = $(event.currentTarget);

        if ($tooltip.hasClass('is-active')) {
            return;
        }

        $tooltips.removeClass('is-active');

        let $inner = $tooltip.find('.tooltip-inner');
        let height = $inner.height();

        if (height > 200) {
            height = ((height / 3 - 25) * (-1));
        } else {
            height = (height / 2 * (-1));
        }

        // Ensure the tooltip doesn't get cut off at the top of the viewport/iframe
        let tooltipOffset = $tooltip.offset().top;
        if (tooltipOffset + height < 60) {
            height = -tooltipOffset + 60;
        }

        if ($inner.find('.close').length < 1) {
            $inner.append(
                $('<span>').addClass('close').text('x')
            );
        }

        $tooltip.find('.tooltip-inner').css({
            'top': height + 'px'
        });

        return $tooltip.addClass('is-active');
    });

    $tooltips.on('mouseleave', event => {
        if ($.inArray(Foundation.MediaQuery.current, ['small', 'xsmall']) >= 0) {
            return;
        }

        let $tooltip = $(event.currentTarget);

        if (!$tooltip.hasClass('is-active')) {
            return;
        }

        return $tooltip.removeClass('is-active');
    });

    $('body').on('click', '.tooltip .close', event => {
        if ($.inArray(Foundation.MediaQuery.current, ['small', 'xsmall']) >= 0) {
            return;
        }

        let $tooltip = $(event.currentTarget).closest('.tooltip');

        if (!$tooltip.hasClass('is-active')) {
            return;
        }

        return $tooltip.removeClass('is-active');
    });
};